import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { UserFromGetSession } from '@/models/user';
import { WorkflowPublic } from '@/models/workflow';
import {
  RequestArticleContextData,
  RequestContextData,
} from '@/routes/Requests/contexts/interfaces';

export const computeAcceptDispatchContext = ({
  view,
  requestView,
  article,
}: {
  request: RequestWithRelations;
  requestView: RequestContextData['view'];
  workflow?: WorkflowPublic;
  article: ArticleWithRelations;
  view: RequestArticleContextData['view'];
  currentSession: UserFromGetSession;
}) => {
  /**
   * SERVICES
   */
  view.services.choice.shown = false;

  const requireWorkshopPrice =
    article.step?.step === 'service-choice' && !!article.step.config.requireWorkshopPrice;

  view.services.actions.fields.workshopPrice.editable = true;
  view.services.actions.fields.workshopPrice.required = requireWorkshopPrice;
  view.services.actions.fields.organizationPrice.editable =
    requestView.organizationPrice.editable &&
    !!article.workshopOrganization?.workshopConfig?.organizationPrice?.editable;

  view.services.actions.fields.spareParts.workshopPrice.editable = true;
  view.services.actions.fields.spareParts.workshopPrice.required = requireWorkshopPrice;
  view.services.actions.fields.spareParts.organizationPrice.editable =
    requestView.organizationPrice.editable &&
    !!article.workshopOrganization?.workshopConfig?.organizationPrice?.editable;

  view.services.none.shown = false;
};
